export default __webpack_public_path__ + "static/media/behavioural-principles.19cc332a.svg";